import React, { useState, useEffect } from "react";
import styled from "styled-components";

import DropWindow from "./../components/DropWindow";

const UL = styled.ul`
  display: inline-block;
   text-align: left;
   margin-top: 0;
   margin-left: auto;
   margin-right: auto;

   li {
    list-style: disc;
    margin-top: 0.8rem;
   }
`;

const OpenTimes = () => {
  return (
    <>
      <h2>ÖPPETTIDER</h2>

      <p>
        Vi öppnar till påsk<br />
        Vi har öppet påskafton, påskdagen och annandag påsk kl 11 till 15.
        <br />
        Därefter har vi öppet lördagar och söndagar kl 11 till 15.
      </p>
      <p>
        Dessutom har vi öppet:<br />
        1 maj<br />
        Kristi himmelfärdshelgen 14, 15 maj.<br />
        Sveriges Nationaldag 6 juni
      </p>
      <p>
        Fr.o.m. skolavslutningen 11 juni har vi öppet varje dag.
      </p>

      {
        /*      
            <UL>
              <li>Vardagar 11 - 17</li>
              <li>Lördagar och söndagar 11 - 16</li>
      
            </UL>
      
            <p>
              Därefter, i september och oktober, kommer vi ha öppet lördagar och söndagar 11 - 15.
            </p>
      
              */
      }

      <p>Varmt välkomna!</p>
    </>
  );
};

function Open() {
  const [dropdown, setDropdown] = useState("");

  function getOpen() {
    setDropdown("open");
  }

  useEffect(() => {
    getOpen();
  }, []);

  return (
    <DropWindow dropdown={dropdown} setDropdown={setDropdown}>
      <OpenTimes />
    </DropWindow>
  );
}

export default Open;